import { useParams } from "wouter";
import { useAuthHook } from "@/hooks/useAuth";
import { useToast } from "@/hooks/use-toast";
import { useEffect } from "react";
import PropertyDataForm from "@/components/propertyDataForm";
import ValuationSidebar from "@/components/valuation-sidebar";

export default function PropertyForm() {
  const { id } = useParams();
  const { toast } = useToast();
  const { isAuthenticated, isLoading } = useAuthHook();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      toast({
        title: "Unauthorized",
        description: "You are logged out. Logging in again...",
        variant: "destructive",
      });
      setTimeout(() => {
        window.location.href = "/api/login";
      }, 500);
      return;
    }
  }, [isAuthenticated, isLoading, toast]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            {id ? "Edit Property" : "New"} Valuation
          </h2>
          <p className="text-gray-600">
            {id
              ? "Update property information and valuation data"
              : "Create a property valuation record"}
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Property Data Collection */}
          <div className="lg:col-span-2">
            <PropertyDataForm isForm={true} />
          </div>

          {/* Valuation Sidebar */}
          <div className="lg:col-span-1">
            <ValuationSidebar propertyId={id} />
          </div>
        </div>
      </div>
    </div>
  );
}
